(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blazingstar-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('blazingstar-hero-overlap')) {
    customElements.define('blazingstar-hero-overlap', class extends HTMLElement {
      connectedCallback() {
        this.headerObserver?.disconnect();
        // section.index can be unavailable during section rendering/editor reloads.
        const main = document.getElementById('MainContent');
        if (this.closest('.shopify-section') !== main?.firstElementChild) return;

        const header = document.querySelector('.section-header');
        const stickyHeader = header?.querySelector('sticky-header[data-sticky-type="always"]');
        if (!stickyHeader) return;

        if (new URLSearchParams(window.location.search).get('hero_debug') === '1') {
          this.startDiagnostics(header, stickyHeader);
        }

        // Only extend behind the header itself, never the announcement bar.
        const updateHeight = () => {
          const height = header.offsetHeight;
          if (height <= 0) return;
          const root = document.documentElement;
          const nextHeight = `${height}px`;
          if (root.style.getPropertyValue('--header-height') !== nextHeight) {
            root.style.setProperty('--header-height', nextHeight);
          }
          this.updateDiagnostics?.();
        };
        updateHeight();
        this.headerObserver = new ResizeObserver(updateHeight);
        this.headerObserver.observe(header);
      }

      disconnectedCallback() {
        this.headerObserver?.disconnect();
        window.removeEventListener('scroll', this.updateDiagnostics);
        window.removeEventListener('resize', this.updateDiagnostics);
        this.diagnostics?.remove();
      }

      // Opt-in read-only panel for real iPhone checks; absent in normal browsing.
      startDiagnostics(header, stickyHeader) {
        this.diagnostics?.remove();
        const panel = document.createElement('details');
        panel.open = true;
        panel.style.cssText = 'position:fixed;bottom:8px;right:8px;z-index:10000;width:min(440px,calc(100vw - 16px));max-height:45vh;overflow:auto;background:#fff;color:#111;border:1px solid #777;padding:8px;font:11px/1.4 monospace;';
        const summary = document.createElement('summary');
        summary.textContent = 'Hero diagnostics (tap to collapse)';
        const output = document.createElement('pre');
        output.style.cssText = 'white-space:pre-wrap;overflow-wrap:anywhere;margin:8px 0 0;';
        panel.append(summary, output);
        document.body.append(panel);
        this.diagnostics = panel;
        const rect = (element) => {
          const { top, bottom, left, right, height } = element.getBoundingClientRect();
          return { top, bottom, left, right, height };
        };
        const properties = (element, pseudo) => {
          const style = getComputedStyle(element, pseudo);
          return Object.fromEntries(['overflow-x', 'overflow-y', 'clip-path', 'position', 'z-index', 'isolation', 'opacity', 'transform', 'filter', 'background-color', 'mask-image', '-webkit-mask-image', 'mask-composite', '-webkit-mask-composite', 'backdrop-filter', '-webkit-backdrop-filter'].map((name) => [name, style.getPropertyValue(name)]));
        };
        const history = [];
        this.updateDiagnostics = () => {
          const wall = this.querySelector('.blazingstar-hero__visual-wall');
          const tracks = this.querySelector('.blazingstar-hero__visual-tracks');
          const height = header.offsetHeight;
          if (history[history.length - 1]?.height !== height) {
            history.push({ height, ms: Math.round(performance.now()) });
          }
          const ancestors = [];
          for (let parent = wall.parentElement; parent; parent = parent.parentElement) {
            ancestors.push({ element: `${parent.tagName}.${parent.className}`, rect: rect(parent), css: properties(parent) });
          }
          const headerRect = rect(header);
          const wallRect = rect(wall);
          output.textContent = JSON.stringify({
            registered: !!customElements.get('blazingstar-hero-overlap'),
            overlapClass: this.classList.contains('blazingstar-hero--header-overlap'),
            initialHeaderHeight: header.dataset.heroInitialHeight,
            dawnHeight: getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
            overlapHeight: getComputedStyle(this).getPropertyValue('--hero-header-overlap'),
            heightHistory: history,
            viewportWidth: document.documentElement.clientWidth,
            pageWidth: document.documentElement.scrollWidth,
            header: headerRect, wall: wallRect, tracks: rect(tracks),
            verticalOverlap: Math.max(0, Math.min(headerRect.bottom, wallRect.bottom) - Math.max(headerRect.top, wallRect.top)),
            wallCSS: properties(wall), tracksCSS: properties(tracks),
            headerCSS: properties(header), stickyHeaderCSS: properties(stickyHeader),
            glassCSS: properties(stickyHeader, '::before'), ancestors
          }, null, 2);
        };
        this.updateDiagnostics();
        window.addEventListener('scroll', this.updateDiagnostics, { passive: true });
        window.addEventListener('resize', this.updateDiagnostics);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
